import { ocrActionTypes } from '@Actions/ocrActions';

const OCRReducer = (state = {}, action) => {
  switch (action.type) {
    case ocrActionTypes.UPLOAD_DOCUMENT_OCR.LOADING: {
      const { uploadDocumentOCRLoading } = action;
      return {
        ...state,
        uploadDocumentOCRLoading,
      };
    }
    case ocrActionTypes.UPLOAD_DOCUMENT_OCR.SUCCESS: {
      const { ocrData } = action;
      return {
        ...state,
        ocrData,
      };
    }
    default: {
      return state;
    }
  }
};

export default OCRReducer;
